import DriveNavigateHandler, { DriveType } from "../../Components/Drive/Common/drive-navigate-handler";
import { useOutletContext } from "react-router";
import FiltersPanel from "../../Components/Filters/FiltersPanel/filters-panel";
import { FilterContext } from "../../Layouts/Dashboard/dashboard";
import { DbMetadataFieldInfos } from "../../Core/Api/Types/db-metadata-field-infos";
import { useMemo, useState } from "react";
import { ObjectLayer } from "../../Core/Api/Types/object-layer";
import { MetadataFieldValueObjectTypes } from "../../Core/Api/Types/metadata-field-value-object-types";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";

function DriveTreeview() {
  // Outlet context used to pass props to parent DashboardLayout through react router dom
  const { selectedItems, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<DbAssetObjectInfos[]>>;
    selectedItems: DbAssetObjectInfos[];
  }>();
  const [openSidebar, setOpenSidebar] = useState(true);
  const [openFiltersPanel, setOpenFiltersPanel] = useState(false);
  const [openFiltersPanelLayer, setOpenFiltersPanelLayer] = useState<ObjectLayer | null>(ObjectLayer.Asset);
  const [openFiltersPanelType, setOpenFiltersPanelType] = useState(MetadataFieldValueObjectTypes.DbAssetObjectInfos);
  const [openFiltersPanelMetadataFields, setOpenFiltersPanelMetadataFields] = useState<
    DbMetadataFieldInfos[] | undefined
  >(undefined);
  // Todo avoid load users in each page change
  const filterPanel = useMemo(() => {
    return (
      <FiltersPanel
        openSidebar={openSidebar}
        layer={openFiltersPanelLayer}
        type={openFiltersPanelType}
        metadataFieldsOverride={openFiltersPanelMetadataFields}
        isDrive={true}
      />
    );
  }, [openSidebar, openFiltersPanelLayer, openFiltersPanelType, openFiltersPanelMetadataFields]);

  return (
    <FilterContext.Provider
      value={{
        setOpenFiltersPanel,
        setOpenFiltersPanelLayer,
        setOpenFiltersPanelType,
        setOpenFiltersPanelMetadataFields,
        openFiltersPanel,
        openFiltersPanelLayer,
        openFiltersPanelType,
        openFiltersPanelMetadataFields,
      }}
    >
      {filterPanel}
      <DriveNavigateHandler
        type={DriveType.Browser}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
    </FilterContext.Provider>
  );
}

export default DriveTreeview;
